import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AutoNavigatePopup = ({ message, navigateTo, delay = 10000 }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(navigateTo);
    }, delay);

    return () => clearTimeout(timer); // Cleanup the timer on unmount
  }, [navigate, navigateTo, delay]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "white",
          padding: "1.5dvh",
          borderRadius: "8px",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.3)",
          textAlign: "center",
          maxWidth: "50dvw",
        }}
      >
        <p className="text-[1.8dvh] font-bold">{message}</p>
        <button
          onClick={() => navigate(navigateTo)}
          className="text-[2dvh] mt-[1dvh] font-bold  text-main bg-[#e7ded5] rounded-[20px] border border-main p-4"
        >
          Go to Services
        </button>
      </div>
    </div>
  );
};

export default AutoNavigatePopup;
